import { ETH_ARB_ID, ETH_BASE_ID, ETH_ID } from '../constants/tokenIds'
import { Chain } from '../interfaces/common'

export const getETHId = (chain: Chain | undefined) => {
  switch (chain) {
    case Chain.ARB:
      return ETH_ARB_ID
    case Chain.BASE:
      return ETH_BASE_ID
    default:
      return ETH_ID
  }
}
